import { render } from "./context_menu.vue?vue&type=template&id=e0f79c96"
import script from "./context_menu.vue?vue&type=script&lang=js"
export * from "./context_menu.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__